module.exports = __webpack_public_path__ + "static/img/step02.4a33c76.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/publicauth/img/step02.jpeg
// module id = 724
// module chunks = 1